import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './styles.scss';

const CorruptTableLayer = ({show}) => {
  return (
    show === true ?
      <div styleName='wrapper'>
        <h3>Something went wrong.</h3>
        <h3>Failed to load table.</h3>
      </div>
      :
      null
  );
};

CorruptTableLayer.propTypes = {
  show: PropTypes.bool.isRequired
};

CorruptTableLayer.defaultProps = {
  show: false
};

export default CSSModules(CorruptTableLayer, styles);



// WEBPACK FOOTER //
// ./components/qual/Table/CorruptTableLayer/CorruptTableLayer.js